import Vue, {CreateElement, VNode} from 'vue';
import App from './App.vue';
import Web3 from 'web3';
import Portis from '@portis/web3';
import router from './routers/router';
import store from './store';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

declare global {
  interface Window {
    router: typeof router,
    store: typeof store,
    web3: typeof web3,
    ethereum: any
    URL: any
  }
}

moment.tz.setDefault(CONFIG.timeZone);

Vue.use(VueMoment, {
  moment
});

// import 'vue-awesome/icons';
// import Icon from 'vue-awesome/components/Icon';
// Vue.component('v-icon', Icon);

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

import Toasted from 'vue-toasted';
import CONFIG from './config';
Vue.use(Toasted, {
  theme: 'toasted-primary',
  position: 'top-center',
  duration: 5000
});

// Datetime picker
import { Settings, DateTime } from 'luxon';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
Vue.use(Datetime);
DateTime.local().setZone(CONFIG.timeZone);
Settings.defaultLocale = 'en';

Vue.config.productionTip = false;

let web3;
(<any>window).router = router;
(<any>window).store = store;

window.addEventListener('load', async () => {
  if (window.ethereum) {
    // Modern dapp browsers...
    console.log('Select Modern dapp browsers..');
    window.web3 = new Web3(window.ethereum);
    await window.ethereum.enable();
    web3 = window.web3;
    initEvents();
    initApp();
  } else if (window.web3) {
    // Legacy dapp browsers...
    console.log('Select Legacy dapp browsers..');
    window.web3 = new Web3(web3.currentProvider);
    web3 = window.web3;
    initApp();
  } else {
    //Portis https://www.portis.io/
    console.log('No Metamask. Select Portis');
    const portis = new Portis(CONFIG.portis.dappId, CONFIG.portis.network, {gasRelay: true});
    portis.config.network.gasRelayHubAddress = CONFIG.portis.gasRelayHubAddress;
    window.web3 = new Web3(portis.provider);
    web3 = window.web3;
    initPortisEvents(portis);
    initPortisApp();
  }
});

function initEvents() {
  window.ethereum.on('accountsChanged', function(accounts) {
    router.push('/');
    initApp();
  });

  window.ethereum.on('networkChanged', function(netId) {
    router.push('/');
    initApp();
  });
}

function initPortisEvents(portis) {
  portis.onLogin((walletAddress, email) => {
    // console.log('onLogin', walletAddress, email);
  });

  portis.onLogout(() => {
    // console.log('User logged out');
  });
}

function initPortisApp() {
  web3.eth.getAccounts((error, accounts) => {
    initApp();
  });
}

function initApp() {
  store.dispatch('resetStates');
  store.commit('setConnectedStatus', true);

  function getBlockNumber() {
    web3.eth.getBlockNumber(function(err, res) {
      store.commit('setBlockNumber', res);
    });
  }

  getBlockNumber();

  setInterval(function() {
    getBlockNumber();
  }, 10000);

  web3.eth.getAccounts((error, accounts) => {
    if (accounts[0]) {
      web3.eth.defaultAccount = accounts[0];
      store.commit('setWallet', web3.eth.defaultAccount);
      if (web3.version.getNetwork) {
        web3.version.getNetwork((err, res) => {
          store.commit('setNetwork', res);
        });
      } else if (web3.eth.net) {
        web3.eth.net.getId(res => {
          store.commit('setNetwork', res);
        });
      }
      store.dispatch('init');
    }
  });
}

new Vue({
  router,
  store,
  render: (h: CreateElement): VNode => h(App)
}).$mount('#app');
